export default {
  id: 'bj-metal-divide',
  name: 'ระบบการบันทึกการแบ่งคอนกรีตในการตัด เบญจพรคอนกรีตโปรดักส์',
  buttonTitle: 'บันทึกการตัดคอนกรีต',
  module: 'MMS',
  level: 'step',
  updatedAt: '2023-02-26',
  version: '0.1.1',
};
